import { FunctionComponent } from "react";
import { BusyButton, ButtonClass } from "@pjs/core-ui";
import { userUiI18n } from "../../i18n/UserUiI18n.const";
import { IConfirmationStepProps } from "../interfaces/IConfirmationStepProps";

export const ConfirmationStep: FunctionComponent<IConfirmationStepProps> = (props) => {
    return (
        <div className="uui-temporary-access__step-container">
            <h3 className="uui-temporary-access__title">{userUiI18n.getString("temporary_access.steps.confirm.title", { stepNumber: "4" })}</h3>
            <p className="uui-temporary-access__description">{userUiI18n.getString("temporary_access.steps.confirm.description")}</p>
            <BusyButton
                isBusy={props.isSending}
                className={ButtonClass.Outlined}
                dataHook="confirmation-button"
                onClick={props.onClick}
                disabled={!props.shouldBeActive}
                ariaLabel={userUiI18n.getString("temporary_access.steps.confirm.button_label")}
                type="submit">
                {userUiI18n.getString("temporary_access.steps.confirm.button")}
            </BusyButton>
        </div>
    );
};
